export default {
  OPEN_CHAT_BOT_POPUP(state, value) {
    state.chatBotPopup = value;
  },
  OPEN_ADD_PRODUCT_TYPE_POPUP(state, value) {
    state.addProductTypePopup = value;
  },
  OPEN_PRODUCT_POPUP(state, value) {
    state.addProductPopup = value;
  },
  OPEN_REDEMPTION_INSTRUCTIONS_POPUP(state, value) {
    state.addRedemptionInstructionsPopup = value;
  },
  OPEN_ORG_PRODUCT_COUPON_LIST_MODAL(state, value) {
    state.openProductCouponsListModal = value;
  },
  OPEN_WORK_TIME_POPUP(state, value) {
    state.workTimePopup = value;
  },
  OPEN_ADD_VALIDATION_POPUP(state, value) {
    state.addValidationPopup = value;
  },
  OPEN_PRODUCT_MINTABLE_CONTRACT_DETAILS_MODAL(state, value) {
    state.openProductMintableContractDetailsModal = value;
  },
  OPEN_NOTIFICATION_POPUP(state, value) {
    state.notificationPanelPopup = value;
  },
};
